import {GameAvalancheReel} from 'src/avalanche/GameAvalancheReel';
import {ReelSymbol} from '@fantasmagames/slot/src/modules/reels/spin/ReelSymbol';
import {TopReelSymbol} from 'src/topreels/TopReelSymbol';
import {Easing, IEasingFunction} from '@fantasmagames/core/src/tween/Easing';
import {ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {Tween} from '@fantasmagames/core/src/tween/Tween';
import {GameReelSymbol} from '../avalanche/GameReelSymbol';
import {GameAvalancheConstants, GameReelConstants} from '../reels/GameReelConstants';

export class TopAvalancheReel extends GameAvalancheReel {

	protected createReelSymbol(): ReelSymbol {
		return new TopReelSymbol();
	}

	protected dropNewSymbolToPosition(
		symIndex: number,
		yPosition: number,
		delay: number,
		easing: IEasingFunction = Easing.Quadratic.In,
		duration: number = GameAvalancheConstants.dropInConfig.dropDuration,
	): Tween {
		const symbol = this._symbols[symIndex] as GameReelSymbol;
		symbol.y =
			yPosition - GameReelConstants.getTopSymbolSlot().height * ReelConstants.MAX_ROW_AMOUNT - GameReelConstants.getReelsOffsetForRow(symIndex).y;
		const dropNewTween: Tween = new Tween(symbol)
			.to({y: yPosition}, duration)
			.easing(easing)
			.delay(delay);
		this.add(dropNewTween);
		dropNewTween.start();

		return dropNewTween;
	}

	protected playRemoveAnimationAt(sym: ReelSymbol, onCompleted: Function): void {
		sym.visible = false;
		onCompleted && onCompleted();
	}
}



// WEBPACK FOOTER //
// ./src/topreels/TopAvalancheReel.ts